import { Link, useLocation, useNavigate } from "react-router-dom";
import css from "./Header.module.css";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  let link = (
    <Link to="/" className={css.home}>
      {"< home"}
    </Link>
  );

  let path = location.pathname.split("/");
  if (path[1] === "good-gather") return;

  if (path[1] === "cart" || path[1] === "checkout") {
    link = (
      <button onClick={() => navigate(-1)} className={css.home}>
        {"< back"}
      </button>
    );
  }

  if (path[1] === "cookbook" && !!path[2]) {
    link = (
      <button onClick={() => navigate("/cookbook")} className={css.home}>
        {"< cookbook"}
      </button>
    );
  }

  if (
    ["/", "/admin/live/view", "/software-engineering/u", "/asmr"].includes(
      location.pathname,
    )
  )
    link = null;

  return <div className={css.header}>{link}</div>;
};

export default Header;
